// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__2N1we","button":"styles_button__3B4TV"};